import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "phoneNumber", "copyButton"];

  connect() {
  }

  openDialog(e) {
    navigator.clipboard.writeText(this.phoneNumberTarget.innerText);

    this.dialogTarget.showModal();
  }

  closeFromBackdropDialog(e) {
    if (e.type == "mousedown" && e.target == this.dialogTarget) {
      this.dialogTarget.close();
    }
  }

  close() {
    this.dialogTarget.close();
  }

  copy(e) {
    navigator.clipboard.writeText(this.phoneNumberTarget.innerText).then(
      () => {
        this.copyButtonTarget.innerText = "скопирован";
        this.copyButtonTarget.classList.add("copied");
      },
    );
  }
}
